/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OtherSystemType = {
    Mailing: 'Mailing',
    Affiliate: 'Affiliate',
    Other: 'Other'
} as const;
export type OtherSystemType = typeof OtherSystemType[keyof typeof OtherSystemType];


export function instanceOfOtherSystemType(value: any): boolean {
    for (const key in OtherSystemType) {
        if (Object.prototype.hasOwnProperty.call(OtherSystemType, key)) {
            if (OtherSystemType[key as keyof typeof OtherSystemType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OtherSystemTypeFromJSON(json: any): OtherSystemType {
    return OtherSystemTypeFromJSONTyped(json, false);
}

export function OtherSystemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemType {
    return json as OtherSystemType;
}

export function OtherSystemTypeToJSON(value?: OtherSystemType | null): any {
    return value as any;
}

export function OtherSystemTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OtherSystemType {
    return value as OtherSystemType;
}

